<template>
    <li>
        <base-card layout="basecard grid-basecard">
            <template #default>
                <div class="aside">
                    <base-logo :icon-type="generateLogo(trackItem.shipmentType)"></base-logo>
                    <div class="divider"></div>
                </div>

                <div class="shipment-code-container">
                    <div v-if="!trackItem?.warehouseData" class="shipment-code">
                        <p v-tooltip="{value: trackItem.poNo?.trim()?.replaceAll(' ', ' , ') || ' ',disabled: trackItem.poNo?.trim()?.split(' ').length <= 1,}"            >
              PO#: {{ poNo }}
            </p>
                        <p v-tooltip="{
                           value: trackItem.houseNo?.trim()?.replaceAll(' ', ' , ') || ' ',
                disabled: trackItem.houseNo?.trim()?.split(' ').length <= 1,
              }"
            >
              H#: {{ houseNo }}
            </p>
                        <p v-tooltip="{
                           value: trackItem.masterNo?.trim()?.replaceAll(' ', ' , ') || ' ',
                disabled: trackItem.masterNo?.trim()?.split(' ').length <= 1,
              }"
            >
              M#: {{ masterNo }}
            </p>
                        <p v-if="
                trackItem.shipmentType !== 'AIR' &&
                  trackItem.shipmentType !== 'TRUCK' &&
                   trackItem.shipmentType !== 'RAILWAY' &&
                  trackItem.shipmentType !== 'Domestic'
              "
                           v-tooltip="{
                           value: trackItem.container?.trim()?.replaceAll(',', ', ' ) || '' ,
                           disabled: trackItem.container?.trim()?.split(',').length <= 1,
              }"
            >
              Container: {{ container }}
            </p>
                    </div>
                    <div v-else class="shipment-code">
                        <p>Item: {{ trackItem?.warehouseData?.itemNo }}</p>
                        <p>Location: {{ trackItem?.warehouseData?.location }}</p>
                    </div>
                    <div class="divider"></div>
                </div>

        <div class="shipment-detail" v-if="trackItem.mileStones?.length > 0">
          <base-route
            class="base-route"
            :progress="trackItem.totalPercentage"
          />
          <div
            class="detail-component"
            v-for="(mileStone, index) in trackItem.mileStones"
            :key="index"
          >
            <base-icon class="icon" :iconId="mileStone.icon" />
            <div class="detail-text">
              <base-dot
                class="base-dot"
                :dot-color="mileStone.active ? '#00a8e2' : '#d9d9d9'"
              />
              <p class="route-status">
                {{ mileStone.description }}
              </p>
              <h3 class="route-location">{{ mileStone.text }}</h3>
            </div>
            <p class="route-timeline">
                {{
                mileStone.act || mileStone.est
                  ? mileStone.act || `est: ${mileStone.est}`
                  : ""
                }}
            </p>
          </div>
        </div>

                <div class="shipment-detail" v-else>
                    <div class="warehouse__details">
                        <base-icon class="icon" iconId="icon-piece" />
                        <p class="route-location">
                            On hand QTY:
                            {{ trackItem?.warehouseData?.qty.toLocaleString("en-US") }} PCS
                        </p>
                    </div>
                </div>

                <div class="aside">
                    <div class="divider"></div>
                    <base-button @click="viewDetail(trackItem?.keyValue)" label="View" />
                </div>
            </template>
        </base-card>
    </li>
</template>

<script>
    import BaseCard from "../common/BaseCard.vue";
    import BaseRoute from "../common/BaseRoute.vue";
    import BaseLogo from "../common/BaseLogo.vue";
    import BaseIcon from "../common/BaseIcon.vue";
    import BaseDot from "../common/BaseDot.vue";

    export default {
        components: { BaseCard, BaseLogo, BaseRoute, BaseIcon, BaseDot },
        data() {
            return {
                iconType: "",
            };
        },
        methods: {
            generateLogo(type) {
                switch (type) {
                    case "AIR":
                        return "icon-plane";
                    case "FCL":
                    case "LCL":
                        return "icon-ship";
                    case "RAILWAY":
                        return "icon-rail";
                    case "TRUCK":
                        return "icon-truck";
                    case "Domestic":
                        return "icon-plane";
                    default:
                        return "icon-warehouse";
                }
            },
            viewDetail(params) {
                //Change symbol(/) to %2F by Ziv at 2023/3/30 VAL-11686
                //this.$router.push(`/TrackAndTrace/detail/${params}`);
                const _inputCode = params.replaceAll("/", "%2F");
                this.$router.push(`/TrackAndTrace/detail/${_inputCode}`);
            },
        },
        props: ["trackItem"],
        computed: {
            poNo() {
                return this.trackItem.poNo?.trim()?.split(" ").length <= 1
                    ? this.trackItem.poNo?.trim() || ""
                    : this.trackItem.poNo?.trim()?.split(" ")[0] + ",...";
            },
            houseNo() {
                return this.trackItem.houseNo?.trim()?.split(" ").length <= 1
                    ? this.trackItem.houseNo?.trim() || ""
                    : this.trackItem.houseNo?.trim()?.split(" ")[0] + ",...";
            },
            masterNo() {
                return this.trackItem.masterNo?.trim()?.split(" ").length <= 1
                    ? this.trackItem.masterNo?.trim() || ""
                    : this.trackItem.masterNo?.trim()?.split(" ")[0] + ",...";
            },
            container() {
                return this.trackItem.container?.trim()?.split(",").length <= 1
                    ? this.trackItem.container?.trim() || ""
                    : this.trackItem.container?.trim()?.split(",")[0] + ",...";
            },
            shortStr(Val) {
                const returnVal = Val.length > 10 ? Val.substr(0, 10) + '...' : Val;
                return returnVal;
            }
        },
        mounted() {
            console.log(this.trackItem);
        },
    };
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
        word-break: break-all;
    }

    li {
        background-color: #fff;
    }

        li:not(last-child) {
            margin-bottom: 2rem;
        }

    .aside {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .shipment-code {
        /* margin-left: 4rem; */
        margin-left: 15%;
        font-size: 1.4rem;
        line-height: 1.9;
        color: #011837;
    }

        .shipment-code p,
        span {
            font-family: MyDimerco-OpenSansBold;
        }

        .shipment-code span {
            word-break: break-all;
        }

    .shipment-code-container {
        display: flex;
        align-items: center;
        position: relative;
        width: auto;
    }

    .divider {
        position: absolute;
        top: 50%;
        width: 1px;
        height: 50%;
        transform: translateY(-50%);
        background-color: #e0e0e0;
    }

        .divider:first-child {
            left: 0;
        }

        .divider:nth-child(2) {
            right: 0;
        }

    .shipment-detail {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        margin: auto 0;
        margin-left: 4rem;
        position: relative;
    }

    .detail-component {
        display: flex;
        flex-direction: column;
    }

    .icon {
        margin-bottom: 0.5rem;
    }

    .detail-text {
        padding-left: 0.9rem;
    }

    .warehouse__details {
        text-align: center;
    }

    .base-dot {
        position: relative;
        margin-bottom: 1rem;
    }

    .base-route {
        position: absolute;
        width: 80%;
        top: 4rem;
        left: 1.4rem;
    }

    .route-status {
        font-size: 1.2rem;
        color: #8b95a0;
        /* line-height: 1.6; */
        margin-bottom: 1rem;
        font-family: MyDimerco-OpenSansRegular;
        font-weight: 900;
    }

    .route-location {
        font-size: 1.6rem;
        font-weight: 700;
        color: #465363;
        /* line-height: 2.2; */
        font-family: MyDimerco-OpenSansBold;
    }

    .route-timeline {
        font-size: 1.4rem;
        color: #465363;
        /* line-height: 1.9; */
        padding-left: 0.9rem;
        margin-top: auto;
    }

    @media (max-width: 105em) { /* 1680px */
        .shipment-code {
            margin-left: 10%;
        }
    }

    @media (max-width: 100em) { /* 1600px */
        .shipment-code {
            margin-left: 7%;
        }
    }

    @media (max-width: 90em) { /* 1440px */
        .shipment-code {
            font-size: 1.2rem;
        }

        .route-status {
            font-size: 1rem;
        }

        .route-location {
            font-size: 1.4rem;
        }

        .route-timeline {
            font-size: 1.2rem;
        }
    }
</style>
